import { sameEquipmentKey } from "@frontier/content/arsenal";
import type { EquipmentDefinition } from "@frontier/content/arsenal";
import { CONTRACTS, SELECTABLE_CONTRACT_IDS } from "@frontier/content/contracts";
import { contractTermsForTemplate, originalContractTemplate } from "@frontier/content/contract-orders";
import { PUBLIC_EVENTS } from "@frontier/content/events";
import { regionRisk } from "@frontier/content/risk";

export function blueprintSources(item: EquipmentDefinition): string[] {
  const sources: string[] = [];
  for (const id of SELECTABLE_CONTRACT_IDS) {
    const blueprint = contractTermsForTemplate(originalContractTemplate(id), "standard").rewards.blueprints.find(reward => sameEquipmentKey(reward.key, item.key));
    if (blueprint) sources.push(`${blueprint.successes} успешный вылет «${CONTRACTS[id].title}»`);
  }
  for (const event of Object.values(PUBLIC_EVENTS)) {
    if (event.blueprintUnlocks.some((key) => sameEquipmentKey(key, item.key)))
      sources.push(
        `${regionRisk(event.sectorId) === "open-pvp" ? "Событие" : "PvE-событие"} «${event.title}» — успех и участие`,
      );
  }
  return sources;
}
